import axios from "axios";

export default {
  login(customerId, password) {
    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: `${process.env.CUSTOMER_SERVICE_PUBLIC_PATH}/login`,
        data: {
          customerId: customerId,
          password: password
        }
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
}


// WEBPACK FOOTER //
// ./src/services/customerService.js